
import { cva } from "class-variance-authority";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Gauge } from "lucide-react";

// Calculate score category
const getScoreCategory = (score: number) => {
  if (score >= 0.9) return "good";
  if (score >= 0.5) return "average";
  return "poor";
};

// Get the color for the score category
const getScoreColor = (category: string) => {
  switch (category) {
    case "good":
      return "text-emerald-500";
    case "average":
      return "text-amber-500";
    case "poor":
      return "text-red-500";
    default:
      return "text-muted-foreground";
  }
};

type MetricCardProps = {
  title: string;
  score: number;
  displayValue: string;
  description?: string;
};

export function MetricCard({ title, score, displayValue, description }: MetricCardProps) {
  const scoreCategory = getScoreCategory(score);
  const colorClass = getScoreColor(scoreCategory);
  
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-baseline justify-between">
          <div className={`text-2xl font-bold ${colorClass}`}>
            {displayValue}
          </div>
          <div className={`flex items-center ${colorClass}`}>
            <Gauge className="mr-1 h-4 w-4" />
            <span className="text-sm">
              {scoreCategory === "good" 
                ? "Good" 
                : scoreCategory === "average" 
                  ? "Needs Improvement" 
                  : "Poor"}
            </span>
          </div>
        </div>
        {description && (
          <p className="mt-2 text-xs text-muted-foreground">{description}</p>
        )}
      </CardContent>
    </Card>
  );
}
